import { createContext } from 'react';

export const context = createContext({
    userIsGuest:           false,
    displayLoader:         false,
    displayUpdatingLoader: false,
});
